import { useOutletContext, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import FormEditorExternal from 'modules/forms/components/editor/externalEditor/FormEditorExternal'
import { TrainingFormContextType } from 'modules/trainings/pages/Trainings/Revamp/TrainingDetail/TrainingFormDetail/types'

const EditQuestions = () => {
  const { trainingForm } = useOutletContext<TrainingFormContextType>()
  const { navigation } = useNavigation()
  const { id } = useParams()

  return (
    <FormEditorExternal
      formId={String(trainingForm.id)}
      resourceType="Trainings::Training"
      navigateBack={navigation.trainings.list.details_revamp.trainingSurveyDetail.questions.fullPath(
        {
          id: String(id),
          formId: trainingForm.id,
        }
      )}
    />
  )
}
export default EditQuestions
